import { Chat } from '@/redux/chat/types'
import { ChatFilters } from '@/redux/chat/handles/setChatFiltersAction/types'
import { normalizeSearchText } from '@/helpers/string.helpers'

export function getFilteredChats(chatsToFilter: Chat[], search: string) {
  if (!search) return chatsToFilter
  return chatsToFilter.filter(
    chat =>
      normalizeSearchText(chat.lastMessage?.messageText)?.includes(search) ||
      normalizeSearchText(chat.requesterNumber?.toString())?.includes(search) ||
      normalizeSearchText(chat?.chatName?.toString())?.includes(search)
  )
}

export function hasActiveFilters(chatFilters: ChatFilters | undefined): boolean {
  if (!chatFilters) return false

  const hasLabels = chatFilters.labels && chatFilters.labels.length > 0
  const hasUra = chatFilters.isUra
  const hasFunnel = chatFilters.isFunnel
  const hasGroup = chatFilters.isGroup
  const hasPeriod = chatFilters.period && chatFilters.period.start && chatFilters.period.end
  const hasCampaigns = chatFilters.campaigns && chatFilters.campaigns.length > 0

  return !!(hasLabels || hasUra || hasFunnel || hasGroup || hasPeriod || hasCampaigns)
}

export function separateChatsByStatusCloseOrArchived(chats: Chat[]) {
  const closeOrArchivedChats: Chat[] = []
  const otherChats: Chat[] = []
  for (const chat of chats) {
    if (chat.status === 'close' || chat.status === 'archived') {
      closeOrArchivedChats.push(chat)
    } else {
      otherChats.push(chat)
    }
  }
  return {
    closeOrArchivedChats,
    otherChats
  }
}

export const playNotificationSound = () => {
  try {
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext
    if (!AudioContextClass) return

    const audioContext = new AudioContextClass()
    const oscillator = audioContext.createOscillator()
    const gainNode = audioContext.createGain()

    oscillator.connect(gainNode)
    gainNode.connect(audioContext.destination)

    oscillator.frequency.setValueAtTime(800, audioContext.currentTime)
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime)
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.5)

    oscillator.start(audioContext.currentTime)
    oscillator.stop(audioContext.currentTime + 0.5)
  } catch (error) {
    console.warn('Sound notification error.', error)
  }
}

export async function sendBrowserNotification({
  title,
  body,
  icon,
  tag
}: {
  title: string
  body: string
  icon: string
  tag?: string
}) {
  if (!('Notification' in window)) return

  // Permissão
  if (Notification.permission === 'granted') {
    // eslint-disable-next-line no-new
    new Notification(title, {
      body,
      icon,
      tag
    })
  } else if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      // eslint-disable-next-line no-new
      new Notification(title, {
        body,
        icon,
        tag
      })
    }
  }
}
